import request from '../../../helpers/request';

const bindTenant = async (values, tenantName, isEdit = false) => {
  const response = await request.put(
    `/HousingStock/bind_client`,
    values,
    `При ${
      isEdit ? 'изменении' : 'добавлении'
    } жильца ${tenantName} произошла ошибка`
  );

  return response;
};

export default bindTenant;
